import React from 'react';
import PropTypes from 'prop-types';

import { decodeHtmlEntities } from 'js/helpers/data';

import InfoBlock from 'js/components/InfoColumnBlocks/InfoBlock';
import styles from './styles.module.css';

const TreatmentFilesSlots = ({ treatmentFiles, headerText }) => {
  if (!treatmentFiles || treatmentFiles.length === 0) {
    return null;
  }

  const blocks = treatmentFiles
    .map((treatmentFile, index) => (
      <InfoBlock
        key={index}
        imageUri={treatmentFile.imageUrl}
        title={treatmentFile.title}
        description={decodeHtmlEntities(treatmentFile.description)}
        uri={treatmentFile.link}
      />
    ))
    .slice(0, 2);

  return (
    <div className={styles.treatmentFilesSlots}>
      <h4 className={styles.header}>{headerText}</h4>
      {blocks}
    </div>
  );
};

TreatmentFilesSlots.propTypes = {
  treatmentFiles: PropTypes.array,
  headerText: PropTypes.string,
};

export default TreatmentFilesSlots;
